export enum NewsTypeEnum {
  PADRAO = 'PADRAO',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}
